// extracted by mini-css-extract-plugin
module.exports = {"metallicBorder":"MetallicBorder_metallicBorder__w8cVE","metallicButtonStyle":"MetallicBorder_metallicButtonStyle__yM89S"};